import { render, staticRenderFns } from "./InsuredDriverDetailsBody.vue?vue&type=template&id=0a29c074"
import script from "./InsuredDriverDetailsBody.vue?vue&type=script&lang=js"
export * from "./InsuredDriverDetailsBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports